import * as React from "react";

const Pictures = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0556 5.84615H1.94444V15.1538H3.83333V16H1V5H18V6.69231H17.0556V5.84615Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1111 9.84615H6.88889V19.1538H21.1111V9.84615ZM6 9V20H22V9H6Z"
      fill="white"
    />
  </svg>
);

export default Pictures;
